// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 淘宝自适应库
import 'lib-flexible/flexible.js'
// import 'amfe-flexible/index.js'

// es6转es5
import 'babel-polyfill'

// 引入swiper滚动插件
import 'swiper/dist/css/swiper.css'

// 引入全局基础css库
import './assets/sass/style.scss';

// 引入动画
import 'animate.css'

// 全局函数
import glf from './common/function';

// 全局属性
import gld from './common/data';

// 网络请求插件
import axios from 'axios';
import VueAxios from 'vue-axios';

// vuex存储
import store from '@/store/index';

// 全局引入api接口
import * as api from './utils/api';


import wlHeader from "@/components/wl-header";
import wlSelect from "@/components/wl-select";
import wlEmpty from "@/components/wl-empty";
Vue.component('wl-header',wlHeader);
Vue.component('wl-select',wlSelect);
Vue.component('wl-empty',wlEmpty);

import theWlAlert from './components/wl-alert/index.js'

import  fastClick from 'fastclick'
//将fastclick自带的方法绑定到document.body之上
// fastClick.attach(document.body);

import {Dialog ,Search,ImagePreview,ShareSheet, IndexBar, IndexAnchor,Popup, Icon ,Picker , Image as VanImage,Uploader,Lazyload, Toast,Loading,List,Sticky,PullRefresh, Checkbox, CheckboxGroup,Swipe, SwipeItem} from 'vant';
Vue.use(Dialog);
Vue.use(Search);
Vue.use(ImagePreview);
Vue.use(ShareSheet);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Uploader);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(VanImage);
Vue.use(VueAxios, axios);
Vue.use(Lazyload);
Vue.use(Sticky);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
// 挂载全局变量
Vue.prototype.$ImagePreview = ImagePreview;

Vue.prototype.$glf = glf;       //全局函数
Vue.prototype.$gld = gld;       //全局数据
Vue.prototype.$api = api;       //全局api
Vue.prototype.$axios = axios;   //全局网络请求

Vue.prototype.$wlAlert = theWlAlert;   //自定义弹框组件挂载

Vue.config.productionTip = false


// 跳转后返回顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  data: function () {
    return {
      load_lock: true
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js